module.exports = "<div class=\"container mt-5 pt-5\" [innerHtml]=\"myTemplate\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/landing/info/contacts/contacts.component.html
// module id = ./src/app/landing/info/contacts/contacts.component.html
// module chunks = main